<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'0px !important'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">Báo cáo yêu cầu điều xe</h5>
    </template>

    <template #body>
      <el-form ref="form" label-position="left" label-width="150px">
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Ngày bắt đầu">
              <el-date-picker
                v-model="startTimeRange"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                placeholder="dd/MM/yyyy"
                :prefix-icon="' '"
                type="daterange"
                range-separator="-"
                format="dd/MM/yyyy"
                :picker-options="dateQuickFilterOption"
                @change="startTimeRangeChanged"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__left">
        <el-button class="btnSolid__blue" size="medium" @click="submit">
          <i class="fas fa-file-export"></i>
          &nbsp;Xuất báo cáo
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import CustomDialog from "../../common/custom-dialog";
import utils from "../../../services/utils";
import constants from "../../../constants";
import dateUtils from "../../../dateUtils";

export default {
  name: "hc-dieuxe-report-dialog",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "id"],
  components: {
    CustomDialog,
  },
  data() {
    return {
      form: {
        fromStartTime: null,
        toStartTime: null,
      },
      startTimeRange: null,
      dateQuickFilterOption: null,
    };
  },

  created() {
    this.initDateQuickFilterOption();
    this.initStartTimeRange();
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
  },

  methods: {
    startTimeRangeChanged() {
      utils.timeRangeChanged(this.startTimeRange, (from_, to_) => {
        this.form.fromStartTime = from_;
        this.form.toStartTime = to_;
      });

      this.initStartTimeRange();
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = utils.getDefaultDateQuickFilterOption();
    },

    initStartTimeRange() {
      if (!this.startTimeRange) {
        utils.timeRangeChanged(
          (this.startTimeRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
          )),
          (from_, to_) => {
            this.form.fromStartTime = from_;
            this.form.toStartTime = to_;
          }
        );
      }
    },

    submit() {
      let query = utils.merge(this.form, {
        userDeptRoleId: this.userDeptRoleId,
      });
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.REPORT.BAO_CAO_DIEU_XE_URL;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
        "_blank "
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-report-dialog.vue